/* eslint-disable */

import React from "react";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

export default function SecuritySectionTitle({ children, mb = 1.5 }) {
  return (
    <MDBox
      mb={mb}
      px={{ xs: 2, sm: 2.5 }}
      py={1.25}
      borderRadius="md"
      sx={({ palette }) => ({
        minWidth: 0,
        backgroundColor: palette.mode === "dark" ? "#263E5B" : "#CCE2F7",
      })}
    >
      <MDTypography
        variant="h6"
        color="inherit"
        fontWeight="bold"
        sx={({ palette }) => ({
          fontSize: "20px",
          color: palette.mode === "dark" ? "#E4F0FC" : "#174A78",
        })}
      >
        {children}
      </MDTypography>
    </MDBox>
  );
}
